import React, { Fragment, useEffect, useState } from 'react'
import './About.scss'
import AnimatedLetter from '../AnimatedLetter/AnimatedLetter'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAndroid,
  faCss3,
  faGithub,
  faHtml5,
  faJsSquare,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const titleArr = ['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
  }, [])
  return (
    <Fragment>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetter
              strArray={titleArr}
              idx={2}
              letterClass={letterClass}
            />
          </h1>
          <p>
            I am a <em>software engineering</em> student at the{' '}
            <strong>University of Information Technology</strong> - Vietnam
            National University in Ho Chi Minh City.
          </p>
          <p>
            I am a person who takes her work seriously, always studying and
            finding quick answers to issues, and always willing to assist people
            in need.
          </p>
          <p>
            I am a nice, easygoing person who enjoys learning new things,
            especially stuff I don't know yet. In my spare time, I like reading
            novels and spending my weekends going out or watching movies.
          </p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faAndroid} />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faHtml5} />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faReact} />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGithub} />
            </div>
          </div>
        </div>
      </div>

      <Loader type="pacman" />
    </Fragment>
  )
}

export default About
